<template>
  <div class="mt-2">
    <v-card>
      <v-toolbar
        dense
        color="white"
        class="elevation-0"
      >
        <v-toolbar-title>
          <v-icon>mdi-account-multiple</v-icon>
          לקוחות
        </v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-footer
          disable-sort
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <router-link :to="`/customers/${item._id}`">{{ item.name }}</router-link>
              </td>
              <td>{{ item.type }}</td>
              <td><a :href="`tel:${item.phone}`">{{ item.phone }}</a></td>
              <td><a :href="`mailto:${item.email}`">{{ item.email }}</a></td>
              <td>{{ item.id }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      headers: [
        { text: "שם", align: "right", value: "name" },
        { text: "תפקיד", align: "right", value: "type" },
        { text: "טלפון", align: "right", value: "phone" },
        { text: "אי-מייל", align: "right", value: "email" },
        { text: "תעודת זהות", align: "right", value: "id" }
      ]
    };
  },
  methods: {
    customerById(id) {
      let customer = this.$store.state.entities.customers[id];
      if (customer) {
        return customer;
      }
    }
  },
  computed: {
    payer() {
      return this.customerById(this.order.payer);
    },
    traveler() {
      return this.customerById(this.order.traveler);
    },
    items() {
      let items = [];
      let customers = [
        Object.assign({ type: "TRAVELER" }, this.traveler),
        Object.assign({ type: "PAYER" }, this.payer)
      ];

      if (this.order.payer === this.order.traveler) {
        customers = [customers[0]];
      }

      for (let customer of customers) {
        items.push({
          _id: customer._id,
          name: customer.name,
          email: customer.email,
          phone: customer.phone,
          id: customer.id,
          type: customer.type === "PAYER" ? "משלם" : "מטייל"
        });
      }
      return items;
    }
  },
  props: ["order"],
  watch: {},
  mounted() {},
  components: {},
  mixins: [mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>